import { Component, Input } from "@angular/core"
import { LearningObject } from "../../models/learningObject.model"
import { CHNode } from "../../models/node.model"

@Component({
    selector: "app-not-found-error",
    templateUrl: "./not-found-error.component.html",
    styleUrls: ["./not-found-error.component.scss"],
})
export class NotFoundErrorComponent {
    public image: string

    @Input()
    public subjects: CHNode[]

    @Input()
    public learningObjects: LearningObject[] = []

    constructor() {
        this.image = require("../../../assets/Student-Teacher-Laptop.png").default
    }
}
